import { getCountryLabel, getCountryName } from '@razz-team/utils';
import { ApiCountryCode } from '../../openapi';
import {
  AvatarCountry,
  AvatarProps,
  FormAutocompleteField,
  FormAutocompleteFieldProps,
} from '@razz-team/ui-web';
import { useCallback } from 'react';
import { ALL_COUNTRY_CODES } from '../../constants/country';

export function CountryField<
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
>({
  options = ALL_COUNTRY_CODES,
  ...props
}: Omit<
  FormAutocompleteFieldProps<ApiCountryCode, Multiple, DisableClearable>,
  'options' | 'getOptionLabel'
> & { options?: ApiCountryCode[] }) {
  const renderAvatar = useCallback((country: string, avatarProps: Partial<AvatarProps>) => {
    return country ? <AvatarCountry country={country} {...avatarProps} /> : undefined;
  }, []);

  return (
    <FormAutocompleteField
      {...props}
      options={options}
      renderAvatar={renderAvatar}
      getOptionLabel={getCountryName}
      renderOption={(props, option) => <li {...props}>{getCountryLabel(option)}</li>}
    />
  );
}
